<template>
    <section>
        <el-table :data="secretKeyList"
            style="width: 100%;"
            max-height="242"
            @selection-change="handleSelectionChange"
            class="secret-key-list">
            <el-table-column
                type="selection"
                :selectable="selectableFun"
                width="55">
            </el-table-column>
            <el-table-column prop="name"
                :label="$t('privateNetInstance.sshName')">
                <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime"
                :label="$t('privateNetInstance.createTime')">
                <template slot-scope="scope">
                    <span>{{ scope.row.createTime}}</span>
                </template>
            </el-table-column>
        </el-table>
        <section class="serect-key-tips">
            <div>  
                <span>{{$t('privateNetwork.noSuitableKey')}}</span>
                <el-button type="text" @click="jumpToKeys">
                    {{ $t('ssh.text.create') }}
                </el-button>
            </div>
            <div>      
                <span>{{$t('create.help.publicKeySetting')}}</span>
                <a :href="Config.SSH_HELP_URL"
                    target="_blank">
                    {{$t('privateNetInstance.operateGuid')}}
                </a>
            </div>
        </section>
    </section>
</template>

<script>
export default {
    name: 'SecretKey',
    model: {
        prop: 'selectKey',
        event: 'changeSelectKey'
    },
    props: {
        region: {
            type: String,
            default: ''
        },
        selectKey: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            secretKeyList: [],
            multipleKeySelection: [], 
        };
    },
    computed: {
    },
    watch: {
        region() {
            this.getSecretKeyList();
        }
    },
    created() {
        this.getSecretKeyList();
    },
    methods: {
        getSecretKeyList() {
            const params = {
                region: this.region,
                pageSize: 200
            };
            Ajax.get('/api/cps/listKeypairs', params)
            .then((res) => {
                this.secretKeyList = res.data.keypairs;
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally();
        },
        selectableFun() {
            return true
        },
        handleSelectionChange(val) {
            this.multipleKeySelection = val;
            let selectKey = val.map(item => item.keypairId).join();
            this.$emit('changeSelectKey',selectKey);
        },
        /**
         * 跳转密钥列表
        */
        jumpToKeys() {
            this.$router.push({
                path: '/ssh/list',
                query: {
                    region: this.region
                }
            });
        },
    },
};
</script>

<style lang="sass">
    @import "./style"
</style>



// WEBPACK FOOTER //
// src/components/common/secretKey/SecretKey.vue